// File: src/config.js
// Build-time configuration.
//
// Lives here rather than in App.js so components don't have to import from the
// application root - that made every component depend on the top-level module
// and becomes a genuine import cycle once routing is added.

// Resolved at build time by Create React App (only REACT_APP_* vars are inlined).
// CI sets REACT_APP_API_BASE_URL from the GitHub Actions `API_BASE_URL` variable;
// the fallback is used for local development when it isn't set.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://rc.rc.local/api';

// Cloudflare Turnstile site key, used on the public (unauthenticated) forms.
// The matching secret lives only on the server as TURNSTILE_SECRET_KEY.
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';
